import { useEffect } from 'react'
import style from  '../../../../sass/pages/profile/profile.module.scss'
import { senderCities } from '../../../../data/static-data'
import { useTranslation } from 'react-i18next'

const SenderCityInput = ({state, setState, enabled }) => {
    const {t} = useTranslation()
    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            return
        }
        setState(e.target.value)
    }

    useEffect(() => {
        if (!state) {
            setState(senderCities[0].value)
            return
        }
    }, [setState, state])

    return (
        <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
            <span className='col-span-4 text-xs text-left font-bold'>
                {t("user.inputs.city.title")}
            </span>
            <select
                className={`${style.select} col-span-4 text-xs text-left font-bold`}
                id="sender-region"
                value={state["sender-region"]}
                onInput={handleChange}
                disabled={!enabled}
            >
                {senderCities.map((option, index) => (
                    <option
                        selected={state === option.value}
                        key={index}
                        value={option.value}
                    >
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
  )
}

export default SenderCityInput